import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
import Flexbox from "flexbox-react";
import _ from "lodash";
import Drawer from "rc-drawer";
import "rc-drawer/assets/index.css";
import React from "react";
import autoBind from "react-autobind";
// import { Button } from "react-bootstrap";
import ReactDOM from "react-dom";
// import Joyride from "react-joyride";

import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import Simplert from "react-simplert";
import * as playerActions from "../../actions/playerActions";
import Alerts from "../../components/Alerts.js";
import playerPaths from "../../constants/paths/playerPaths";
import { getConfigParam } from "../../utils/config";
import * as Utils from "../../utils/utils";
import { handleLaunchInNewTab, isInIFrame } from "../../utils/utils";
import Breadcrumb from "../nav/Breadcrumb";
import BreadcrumbDialog from "../nav/BreadcrumbDialog";
import Checkbar from "../shared/Checkbar";
import DraggableScrollContainer from "../shared/DraggableScrollContainer";
import Loader from "../shared/loader";
import ActivityPlayer from "./ActivityPlayer";
import Lists from "./Lists";
import NavigationView from "./NavigationView";
import CountdownTimer from "../timer/CountdownTimer";
import EmbeddedTimer from "../timer/EmbeddedTimer";
import QuickToolbar from "../shared/QuickToolbar";
import SyntheticVoiceApi from "../../speech/SyntheticVoiceApi";
import * as actionsTimerManager from "../../actions/actionsTimerManager";
import FixedValuesPanel from "../shared/FixedValuesPanel";
import RelatedItem from "../shared/button/RelatedItem";
import ItemModal from "../views/ItemModal";
import { hidePromptModal } from "../../actions/modalActions";
import PromptModal from "../shared/PromptModal";
import ReleaseNotesModal from "../shared/ReleaseNotesModal";


const headerStyle = {
	backgroundColor: "#121212",
	justifyContent: "space-between",
	alignItems: "center",
	paddingTop: 0,
	shadowColor: "#000",
	shadowOffset: { width: 0, height: 2 },
	shadowOpacity: 0.1,
	shadowRadius: 1.5,
	height: 55,
	elevation: 2,
	position: "relative",
	display: "flex",
	flexDirection: "row"
};

// const headerStyleExpanded = {
// 	backgroundColor: "#121212",
// 	justifyContent: "space-between",
// 	alignItems: "center",
// 	paddingTop: 0,
// 	shadowColor: "#000",
// 	shadowOffset: { width: 0, height: 2 },
// 	shadowOpacity: 0.1,
// 	shadowRadius: 1.5,
// 	height: 85, /* MiraCheck uses 60 on iOS and 70 on Android */
// 	elevation: 2,
// 	position: "relative",
// 	display: "flex",
// 	flexDirection: "row"
// };

class PlayerProcedure extends React.PureComponent {

	constructor(props) {
		super(props);
		this.listScrollContainerRef = React.createRef();
		this.state = {
			steps: [
				{
					target: "#jr-side-menu",
					content: "This is the side menu that allows you to adjust settings for the web player.",
					disableBeacon:true
				},
				{
					target: "#jr-breadcrumb",
					content: "The breadcrumb bar will display your current location."
				},
				{
					target: "#jr-breadcrumb-search",
					content: "The search button will open the tree hierarchy of the current procedure and allow you to search for specific content.",
					placement:"left-end"
				},
				{
					target: "#jr-breadcrumb-birdseye",
					content: "Birdseye view gives you a high level overview of all sections and allows you to quickly navigate.",
					placement: "left-end"
				},
				{
					target: "#jr-lists",
					content: "The tabs on the bottom are the lists in the procedure, you can navigate to them by tapping or clicking.",
					placement:"top-start"
				}
			]
		};
		autoBind(this);
	}

	componentDidMount() {
		//no quick toolbar, start clock here		
		this.props.dispatch(
			actionsTimerManager.startClock
		);
	}

	handleSave() {
		this.props.dispatch(
			playerActions.saveActivity
		);
	}

	handleSaveAndExit(submit=false) {
		this.props.dispatch(
			playerActions.saveActivityAndExit,
			submit
		);
	}

	handleExit() {
		this.props.dispatch(
			playerActions.exit
		);
	}

	handleExpandAll() {
		this.props.dispatch(
			playerActions.expandAll
		);
	}

	handleCollapseAll() {
		this.props.dispatch(
			playerActions.collapseAll
		);
	}

	handleGoBackFromLink() {
		this.props.dispatch(
			playerActions.goBackFromLink
		);
	}

	handleBackDismiss() {
		this.props.dispatch(
			playerActions.goBackDismiss
		);
	}

	handleNavigateNext() {
		this.props.dispatch(
			playerActions.gotoNextItem
		);
	}

	handleNavigatePrevious() {
		this.props.dispatch(
			playerActions.gotoPreviousItem
		);
	}

	handleCheck() {
		this.props.dispatch(
			playerActions.setNextItemChecked
		);
	}

	handleSkip() {		
		this.props.dispatch(
			playerActions.skipItem
		);
	}

	handleOpenInNewTab() {
		handleLaunchInNewTab();
	}


	handleReplay() {
		this.props.dispatch(
			playerActions.clearCurrentActivityNoConfirm
		);
	}

	handleLocate() {
		this.props.dispatch(
			playerActions.setScrollToSelectedItem,
			true
		);
		SyntheticVoiceApi.stop();
		SyntheticVoiceApi.speak("Selected item located");
	}

	handleBirdseyeView() {
		this.props.dispatch(
			playerActions.toggleSectionsMenuVisible
		);
	}

	handleShowHideNavigationView(show) {
		this.props.dispatch(
			playerActions.showHideNavigationView,
			show
		);
	}

	getDrawerContainer() {
		return ReactDOM.findDOMNode(this);
	}

	performPromptModalMoveForwardAction() {
		this.props.dispatch(
			playerActions.moveForward
		);
	}

	performPromptModalReturnAction() {
		this.props.dispatch(
			playerActions.returnToSkippedItems
		);
	}

	handleCloseItemModal() {
		this.props.dispatch(playerActions.hideItemModal);
	}

	performPromptModalAction() {

		const { affirmativeAction } = this.props.promptModal;
		// console.log("Perform affirmative action", affirmativeAction);
		if (affirmativeAction === "resetCurrentChecklist" || affirmativeAction === "resetCurrentActivity") {
			playerActions.clearCurrentActivityNoConfirm(this.context.tree);
		} else if (affirmativeAction === "resetCurrentList") {
			playerActions.clearCurrentListNoConfirm(this.context.tree);
		} else if (affirmativeAction === "resetCurrentSection") {
			playerActions.clearCurrentSectionNoConfirm(this.context.tree);
		} else if (_.isFunction(affirmativeAction)) {
			affirmativeAction();
		}
		hidePromptModal();
	}

	performPromptModalNegativeAction() {

		const { negativeAction } = this.props.promptModal;
		// console.log("Perform negative action", negativeAction);
		if (negativeAction === "resetCurrentChecklist") {
			playerActions.clearCurrentActivityNoConfirm(this.context.tree);
		} else if (negativeAction === "resetCurrentList") {
			playerActions.clearCurrentListNoConfirm(this.context.tree);
		} else if (negativeAction === "resetCurrentSection") {
			playerActions.clearCurrentSectionNoConfirm(this.context.tree);
		} else if (_.isFunction(negativeAction)) {
			negativeAction();
		}
		hidePromptModal();
	}

	handleJoyrideStateChange(props) {
		console.log("JOYRIDE State Change", props);
	}

	render() {
		const content = this.props.content;

		// console.log("RENDER procedure", this.props);
		let self = this;
		let activity;
		let currentActivity = this.props.activity;
		let activityMetaData = Utils.getActivityMetaData(this.props.activity.id);
		let trackData = activityMetaData.trackData;
		

		const showHeaderPanel = getConfigParam("showHeaderPanel", true);

		if (_.isEmpty(this.props.activity)) {
			activity = <div></div>;
		} else {
			activity = <ActivityPlayer activity={this.props.activity} showAcceptDefaultButton={true} showMode={false} scrollToSelectedItem={this.props.scrollToSelectedItem} showHeaderPanel={showHeaderPanel}/>;
		}

		/*
		let classPlayerButtonsContainer = "player-buttons-container";
		if (this.props.activity.firstLevel === "items") {
			classPlayerButtonsContainer = "player-buttons-container-hidden"
		}
		*/

		const iframe = isInIFrame();
		// const showControls = getConfigParam("showControls");	

		let activityListViewMode = (this.props.activity.listViewMode) ? this.props.activity.listViewMode : "list";
		let listViewMode = getConfigParam("listViewMode", activityListViewMode);

		// Hardwire for now because of Quickbar
		let showListsToolbar = true;

		if (listViewMode === "list" && getConfigParam("showListsToolbar", true) && this.props.activity.firstLevel === "lists") {
			showListsToolbar = true;
		}

		const isAssignment = trackData !== false && this.props.assignmentId;

		// Don't set fix height
		let listsToolbar = (showListsToolbar) ? <div style={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
			<DraggableScrollContainer listScrollContainerRef={this.listScrollContainerRef} style={{overflow: "hidden", flex: 1, right: 0, /*height: "50px",*/ backgroundColor: "rgba(0,0,0)", color: "white", display: "flex", alignItems: "center" }}>
				<Lists listScrollContainerRef={this.listScrollContainerRef} activity={this.props.activity} />
			</DraggableScrollContainer>
			<div>
				<QuickToolbar backgroundColor="rgba(0, 0, 0, 1)" showClock={true} showSaveActions={true} showSubmitButton={isAssignment} showSideMenuOpen sideMenuOpenAction={() => this.props.dispatch(
					playerActions.showHideNavigationView,
					true,
					"left") 
				} />
			</div>
		</div> : null;

		let checkbarVisibility = Utils.getCheckbarVisibility(this.context.tree);
		const checkbar = (checkbarVisibility !== "hidden") ? <Checkbar onCheck={this.handleCheck} onSkip={this.handleSkip} onLocate={this.handleLocate} onBirdseyeView={this.handleBirdseyeView} /> : null;


		// const isNonDefaultPersistence = this.props.persistenceType && this.props.persistenceType.toLowerCase() !== "default";
		// const expandCollapseAvailable = this.props.activity.firstLevel === "lists" || this.props.activity.firstLevel === "sections";

		let playerActivityContent = [];
		let playerActivityContentFlexDirection = "row";

		let checkbarHiddenAndVisible = this.props.appPreferences.checkbarLocation === "hidden" && checkbarVisibility === "visible";

		let playerActivityContainerHeight = (this.props.appPreferences.checkbarLocation === "bottom" && !checkbarHiddenAndVisible) ? `calc(100% - ${this.props.appPreferences.checkbarSize}px)` : "100%";

		let activityContainer = <div key="activity-container" style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }}>{activity}</div>;
		let checkbarContainer = <div key="checkbar-container" style={{ display: "flex", flexDirection: "column" }}>{checkbar}</div>;

		if (this.props.appPreferences.checkbarLocation === "left") {
			if(this.props.appPreferences.checkbarLocation !== "hidden") {playerActivityContent.push(checkbarContainer);}
			playerActivityContent.push(activityContainer);
		} else {
			playerActivityContent.push(activityContainer);
			if (this.props.appPreferences.checkbarLocation !== "hidden" || checkbarHiddenAndVisible) {playerActivityContent.push(checkbarContainer);}

			if (this.props.appPreferences.checkbarLocation !== "right" && !checkbarHiddenAndVisible) {
				playerActivityContentFlexDirection = "column";
			}
		}


		const timersList = [];
		const modalTimersList = [];
		let embeddedTimer = null;
		// let overrideSpeechRecognitionTrial = false;
		let embeddedTimerDefinition = {};

		this.props.timersList.forEach((timerKey, i) => {
			const timer = self.context.tree.get(["timers", timerKey]);

			if (timer.hasOwnProperty("mode") && timer.mode === "modal") {
				modalTimersList.push(
					<CountdownTimer key={"timer" + i} timer={timer} timerKey={timerKey} compact={true} />
				);
			} else if (timer.hasOwnProperty("mode") && timer.mode === "appBar") {
				embeddedTimerDefinition = timer;
				embeddedTimer = <div style={{ height: "100%", flex: 2 }}><EmbeddedTimer timerKey={timerKey} /></div>;
			} else {
				timersList.push(
					<CountdownTimer key={"timer" + i} timer={timer} timerKey={timerKey} compact={true} />
				);
			}
		});

		// console.log(timersList);
		let timerControl = [];
		if (this.props.timerVisible && (timersList.length > 0 || modalTimersList.length > 0)) {
			if (timersList.length > 0) {
				let hideDismiss = false;
				this.props.timersList.forEach((timerKey) => {
					const timer = self.context.tree.get(["timers", timerKey]);

					if (timer.hasOwnProperty("hideDismiss") && timer.hideDismiss) {
						hideDismiss = true;
					}
				});

				timerControl.push(
					<div key="timer-control-default" style={{position: "absolute", top: 0, right: 10, left: 10, height: "auto", zIndex: 999}}>
							
						{!hideDismiss &&
							<div style={{
								display: "flex", flex: 1, alignItems: "center", justifyContent: "center", width: "100%", backgroundColor: "#888888",
								opacity: 0.9, alignSelf: "center"
							}} onClick={() => {
								this.props.dispatch(
									actionsTimerManager.setTimerVisible,
									false
								);
							}}>
								<span style={{ padding: 3, color: "white", fontSize: 24, fontWeight: "bold", cursor: "pointer" }}>Dismiss</span>
							</div>
						}
						<div style={{
							display: "flex", flexDirection: "column", flex: 8, alignItems: "center", justifyContent: "center", width: "100%", backgroundColor: "red",
							opacity: 0.9, alignSelf: "center"
						}} onClick={() => {
							//this._showLogbook();
						}}>
							{timersList}
						</div>
					</div>);
			}

			if (modalTimersList.length > 0) {
				let hideDismiss = false;
				this.props.timersList.forEach((timerKey) => {
					const timer = self.context.tree.get(["timers", timerKey]);

					if (timer.hasOwnProperty("hideDismiss") && timer.hideDismiss) {
						hideDismiss = true;
					}
				});

				timerControl.push(
					<div key="timer-control-full-screen" style={{display: "flex", position: "absolute", top: 0, right: 0, left: 0, bottom: 0, flexDirection: "column",
						alignItems: "center", justifyContent: "center", flex: 1, zIndex: 999}}>
						{!hideDismiss &&
							<div style={{
								display: "flex", flex: 1, alignItems: "center", justifyContent: "center", width: "100%", backgroundColor: "#888888",
								opacity: 0.9, alignSelf: "center"
							}} onClick={() => {
								this.props.dispatch(
									actionsTimerManager.setTimerVisible,
									false
								);
							}}>
								<span style={{ padding: 3, color: "white", fontSize: 36, fontWeight: "bold", cursor: "pointer" }}>Dismiss</span>
							</div>
						}
						<div style={{
							display: "flex", flexDirection: "column", flex: 8, alignItems: "center", justifyContent: "center", width: "100%", backgroundColor: "red",
							opacity: 0.9, alignSelf: "center"
						}}>
							{modalTimersList}
						</div>
					</div>);
			}
		}


		let moveForwardOpts = {};
		moveForwardOpts.onConfirm = this.performPromptModalReturnAction;
		moveForwardOpts.useConfirmBtn = true;
		moveForwardOpts.onClose = this.performPromptModalMoveForwardAction;
		moveForwardOpts.customConfirmBtnText = "Return";
		moveForwardOpts.customConfirmBtnClass = "simplert-button-transparent";
		moveForwardOpts.customCloseBtnText = "Move Forward";
		moveForwardOpts.customCloseBtnClass = "simplert-button-orange";
		moveForwardOpts.type = "warning";
		moveForwardOpts.disableOverlayClick = true;
		moveForwardOpts.message = content.alerts.skippedItems;
		moveForwardOpts.showSimplert = this.props.promptModalMoveForwardVisible;

		let promptModalMoveForward = <Simplert {...moveForwardOpts} />;

		let promptModal = <PromptModal embeddedTimer={embeddedTimer} affirmativeAction={this.performPromptModalAction} negativeAction={this.performPromptModalNegativeAction}/>;

		/*
		 * Related items
		 */
		let relatedItems = [];
		if (currentActivity && currentActivity.hasOwnProperty("relatedItems") && !_.isEmpty(currentActivity.relatedItems) && _.isArray(currentActivity.relatedItems)) {
			let selectedListIndex = _.get(currentActivity, "selected.listIndex", null);
			let selectedSectionIndex = _.get(currentActivity, "selected.sectionIndex", null);
			let selectedItemIndex = _.get(currentActivity, "selected.itemIndex", null);


			let relatedItemsMap = {};
			currentActivity.relatedItems.forEach(relatedItem => {
				const { id } = relatedItem;
				relatedItemsMap[id] = relatedItem;
			});

			let currentList;
			if (selectedListIndex !== null) {
				currentList = _.get(currentActivity, `children.${selectedListIndex}`, null);
			}
			let i = 0;
			if (currentList && currentList.hasOwnProperty("relatedItemRefs") && _.isString(currentList.relatedItemRefs) && currentList.relatedItemRefs !== "") {
				const relatedItemIds = currentList.relatedItemRefs.split(",");
				relatedItemIds.forEach(id => {
					i++;
					if (relatedItemsMap[id]) {
						const relatedItem = relatedItemsMap[id];
						if (relatedItem) {
							const linkUrl = relatedItem.linkUrl;

							// JJB Hardwiring index to 0 may be problem if 0 is not visible
							relatedItems.push(
								<div key={"relatedItemList-" + i} style={{ padding: 10 }}>
									<RelatedItem onClick={() => {
										self.props.dispatch(playerActions.linkUrl, linkUrl);
									}} relatedItem={relatedItem} />
								</div>
							);
						}
					}
				});
			}

			let currentSection;
			if (selectedListIndex !== null && selectedSectionIndex !== null) {
				currentSection = _.get(currentActivity, `children.${selectedListIndex}.children.${selectedSectionIndex}`, null);
			}

			if (currentSection && currentSection.hasOwnProperty("relatedItemRefs") && _.isString(currentSection.relatedItemRefs) && currentSection.relatedItemRefs !== "") {
				const relatedItemIds = currentSection.relatedItemRefs.split(",");
				relatedItemIds.forEach(id => {
					i++;
					if (relatedItemsMap[id]) {
						const relatedItem = relatedItemsMap[id];
						if (relatedItem) {
							const linkUrl = relatedItem.linkUrl;

							// JJB Hardwiring index to 0 may be problem if 0 is not visible
							relatedItems.push(
								<div key={"relatedItemList-" + i} style={{ padding: 10 }}>
									<RelatedItem onClick={() => {
										self.props.dispatch(playerActions.linkUrl, linkUrl);
									}} relatedItem={relatedItem} />
								</div>
							);
						}
					}
				});
			}

			let currentItem;
			if (selectedListIndex !== null && selectedSectionIndex !== null && selectedItemIndex !== null) {
				currentItem = _.get(currentActivity, `children.${selectedListIndex}.children.${selectedSectionIndex}.children.${selectedItemIndex}`, null);
			}

			if (currentItem && currentItem.hasOwnProperty("relatedItemRefs") && _.isString(currentItem.relatedItemRefs) && currentItem.relatedItemRefs !== "") {
				const relatedItemIds = currentItem.relatedItemRefs.split(",");
				relatedItemIds.forEach(id => {
					i++;
					if (relatedItemsMap[id]) {
						const relatedItem = relatedItemsMap[id];
						if (relatedItem) {
							const linkUrl = relatedItem.linkUrl;

							// JJB Hardwiring index to 0 may be problem if 0 is not visible
							relatedItems.push(
								<div key={"relatedItemList-" + i} style={{ padding: 10 }}>
									<RelatedItem onClick={() => {
										self.props.dispatch(playerActions.linkUrl, linkUrl);
									}} relatedItem={relatedItem} />
								</div>
							);
						}
					}
				});
			}



		}
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		const { appBar } = theme;

		// Added fontSize
		const _nameStyle = _.assign({}, appBar.activityName, _.pick(Utils.getStyleAttribute(this.props.activity, [], ["activity", "title"]), ["color", "fontFamily", "fontWeight", "fontStyle", "fontSize"]));
		console.log("Activity name style", _nameStyle, appBar.activityName);
		const appBarIconName = appBar.sideMenuIcon.name;
		const appBarIconStyles = _.assign({}, { fontSize: "24px", cursor: "pointer" }, appBar.sideMenuIcon);
		//const containerStyle = _.assign({}, { width: "100%", right: 0, height: "50px", zIndex: 999, backgroundColor: "rgba(0,0,0)", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: "10px", paddingBottom: "10px" }, appBar.container);

		// const quickToolbar =
		// 	<QuickToolbar backgroundColor="rgba(0, 0, 0)" showClock={true} showSaveActions={true} showSubmitButton={false} showSideMenuOpen sideMenuOpenAction={() => this.handleShowHideNavigationView(true) } />;

		const _headerStyle = _.assign({}, headerStyle, theme.appBar.container);
		let variables = {};
		const { stateVariables, fixedValues } = this.props;
		if (stateVariables && _.isPlainObject(stateVariables)) {
			_.keys(stateVariables).forEach(key => {
				variables[key] = stateVariables[key].value;
			});
		}
		let hasFixedValues = false;
		if (fixedValues && _.isArray(fixedValues) && stateVariables) {

			fixedValues.forEach((child) => {

				const _variables = child.display.match(/\$\{(.+?)\}/g);

				console.log("Variables", _variables);

				if (_variables && _variables.length > 0) {
					// let hasAllRequiredVariables = false;
					let varCount = _variables.length;
					let foundVariables = 0;
					_variables.forEach(variable => {
						const rawVariable = variable.replace("${variables['", "").replace("']}", "").replace("${variables.", "").replace("}", "");
						if (variables.hasOwnProperty(rawVariable) && !_.isEmpty(variables[rawVariable])) {
							foundVariables++;
						}
					});
					if (foundVariables === varCount) {
						hasFixedValues = true;
					}
				}
			});
		}


		if (this.props.fixedValues) {
			_headerStyle.height += 40;
		}

		const fixedValuesPanel = <FixedValuesPanel />;

		const hideMenuIcon = !!theme.appBar.hideMenuIcon && embeddedTimerDefinition && embeddedTimerDefinition.viewType === "top-left";
		const hideTitle = !!theme.appBar.hideTitle && embeddedTimerDefinition && embeddedTimerDefinition.viewType === "top-left";

		let completedColor = "transparent";
		if (currentActivity.hasOwnProperty("id")) {
		  if (currentActivity.completionState === "c") {
			completedColor = "#82B629";
		  } else if (currentActivity.completionState === "i") {
			completedColor = "#F9A200";
		  } else {
			completedColor = "#BA282A";
		  }  
		}	

		


		let page = <Flexbox flexDirection="column" style={{ overflowY: "hidden", width: "100%", height: "100%" }}>
			{/* <Joyride callback={this.handleJoyrideStateChange} steps={this.state.steps} showProgress continuous debug showSkipButton spotlightClicks/> */}
			<Alerts />
			<Flexbox flexDirection="column" width="100%" height="100%" style={{ minHeight: 0, paddingTop: iframe && showHeaderPanel ? "50px" : 0, paddingBottom: 0 }} className="player-container">
				{
					/*
					!showHeaderPanel && <div style={{ position: "fixed", top: 0, left: 0, width: "100%", right: 0, height: "50px", zIndex: 999, backgroundColor: "rgba(0,0,0,.8)", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
					{goBackControl}
					{(this.props.activity.firstLevel === "lists" || this.props.activity.firstLevel === "sections") &&
						<div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", alignContent: "flex-start", marginRight: "10px" }}>
							<Button title="Expand all" bsStyle="primary" onClick={this.handleExpandAll} style={{ marginRight: "10px" }}><FontAwesomeIcon icon="expand" /></Button>
							<Button title="Collapse all" bsStyle="primary" onClick={this.handleCollapseAll} style={{ marginRight: "10px" }}><FontAwesomeIcon icon="compress" /></Button>
							{isNonDefaultPersistence &&
								<div>
									{trackData !== false && <Button bsStyle="primary" onClick={this.handleSave} style={{ marginRight: "10px" }}>Save</Button>}
									{trackData !== false && <Button bsStyle="primary" onClick={this.handleSaveAndExit}>Save + Exit</Button>}
									{trackData === false && <Button bsStyle="primary" onClick={this.handleExit}>Exit</Button>}
								</div>
							}
						</div>
					}				
					</div>
					*/
				}				
				{showHeaderPanel && <div style={_.assign(_headerStyle,(theme.appBar.imageBackground && !_.isEmpty(theme.appBar.imageBackground)) ? {backgroundImage: `url('${theme.appBar.imageBackground}')`,backgroundRepeat: "no-repeat", backgroundSize: "auto"} : {})}>			
					{(embeddedTimerDefinition.viewType === "top-left" && embeddedTimer) ? embeddedTimer : null}
					{!(hideMenuIcon && hideTitle) && <div className={`panel-main-header-title${!hasFixedValues?" no-fixed-values":""}`} style={{ flex: 1, color: "white", fontWeight: 600, fontSize: "11px", paddingLeft: "10px", fontFamily: "\"Thasadith\", sans-serif", display: "flex", flexDirection: "row", alignItems: "center", height: "100%" }}>
						{/*<div>Powered By<br /><a href="https://www.ambifi.com"><img src="./ambifi-logo-powered-by.png" alt="AmbiFi Logo" style={{ width: "78px", height: "25px", marginLeft: "-5px" }} /></a></div> */}
						{!hideMenuIcon && <div style={{ marginLeft: "5px" }}><FontAwesomeIcon id="jr-side-menu" icon={appBarIconName} style={appBarIconStyles} onClick={() => { this.handleShowHideNavigationView(true); }} /></div>}
						{!hideTitle && <div style={_.assign({ marginLeft: 16, marginRight: 16, fontSize: "20px", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }, _nameStyle)}>{this.props.activity.name}</div>}
					</div>}
					{hasFixedValues && <div className="panel-fixed-values" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", paddingRight: "10px", flex: 0, whiteSpace: "nowrap" }}>
						{/*
							<div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", alignContent: "flex-start", marginRight: "10px" }}>
								{isNonDefaultPersistence &&
									<div>
										{trackData !== false && <Button bsStyle="primary" onClick={this.handleSave} style={{ marginRight: "10px" }}>Save</Button>}
										{trackData !== false && <Button bsStyle="primary" onClick={() => this.handleSaveAndExit()}>Save + Exit</Button>}
										{trackData !== false && this.props.assignmentId && <Button bsStyle="success" style={{ marginLeft: "10px" }} onClick={() => this.handleSaveAndExit(true)}><FontAwesomeIcon icon="check" /> Submit</Button>}
										{trackData === false && <Button bsStyle="primary" onClick={this.handleExit}>Exit</Button>}
									</div>
								}
							</div>
						*/}
						{fixedValuesPanel}
					</div>}
					{(embeddedTimerDefinition.viewType === "top-right" && embeddedTimer) ? embeddedTimer : null}					
				</div>}
				{showHeaderPanel && <div style={{ width: "100%" }}><Breadcrumb /></div>}
				{!currentActivity.hideStatus &&
					<div style={{ position: "relative", width: "100%", height: 5, backgroundColor: currentActivity.hideStatus ? "transparent" : "#BA282A"}}>
						<div style={{ position: "absolute", bottom: 0, left: 0, width: ((currentActivity.progressCount/currentActivity.progressTotal)*100) + "%", height: 5, backgroundColor: completedColor}}/>
					</div>
				}
				<div className="player-activity-container" style={{position: "relative"}}>
					<BreadcrumbDialog />
					<FixedValuesPanel overlayPanelMode/>
					<div style={{display: "flex", flexDirection: "row", width: "100%", height: "100%"}}>
						<div style={{ display: "flex", flexDirection: playerActivityContentFlexDirection, width: "100%", height: playerActivityContainerHeight }}>						
							{playerActivityContent}						
						</div>
						{relatedItems.length > 0 &&
							<div style={{ flex: 1, backgroundColor: "white", display: "flex", flexDirection: "column" }}>
								<div style={{ flex: 0, color: "black", paddingTop: 10, paddingLeft: 10, paddingRight: 10, fontWeight: "bold" }}>RELATED</div>
								<div style={{ flex: 1, overflow: "auto"}}>
									{relatedItems}
								</div>
							</div>
						}
					</div>
				</div>
				{timerControl}
				{listsToolbar}			
				{/* {quickToolbar} */}
			</Flexbox>
			
			{/*
				showControls && <div style={{ position: "fixed", bottom: 0, left: 0, width: "100%", right: 0, height: "50px", zIndex: 999, backgroundColor: "rgba(0,0,0,.4)", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
					<div style={{ paddingLeft: "10px" }}>{goBackControl}</div>
					<div />
					<div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingRight: "10px" }}>

						{isNonDefaultPersistence && trackData !== false && <Button style={{ marginRight: "5px" }} bsStyle="primary" onClick={this.handleSave}>Save</Button>}
						{isNonDefaultPersistence && trackData !== false && <Button style={{ marginRight: "15px" }} bsStyle="primary" onClick={this.handleSaveAndExit}>Save + Exit</Button>}
						{isNonDefaultPersistence && trackData === false && <Button style={{ marginRight: "15px" }} bsStyle="primary" onClick={this.handleExit}>Exit</Button>}

						<Button style={{ marginRight: "5px" }} disabled={!this.props.activity.hasPrevious} onClick={this.handleNavigatePrevious}><FontAwesomeIcon icon="chevron-up" /></Button>
						<Button style={{ marginRight: "15px" }} disabled={!this.props.activity.hasNext} onClick={this.handleNavigateNext}><FontAwesomeIcon icon="chevron-down" /></Button>
						<Button bsStyle="success" onClick={this.handleCheck}><FontAwesomeIcon icon="check" /></Button>
					</div>
				</div>
			*/}
					
			<Loader fullPage show={this.props.showSpinner} />
			
			{
				showHeaderPanel &&
				<Drawer open={this.props.showNavigationView} placement={this.props.showNavigationViewPlacement ? this.props.showNavigationViewPlacement : "left"} onClose={() => { this.handleShowHideNavigationView(false); }} showMask={true} level={null} handler={null} maskClosable={true} getContainer={this.getDrawerContainer()}>
					<NavigationView />
				</Drawer>
			}
			<ReleaseNotesModal/>
			{promptModal}
			{promptModalMoveForward}			
				<ItemModal isOpen={this.props.itemModalVisible} topMargin={embeddedTimer !== null} currentActivity={currentActivity} onClickClose={this.handleCloseItemModal} />
		</Flexbox>;

		return page;
	}
}

PlayerProcedure.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	activity: ["activity"],
	navStack: ["player", "navStack"],
	showSpinner: ["player", "showSpinner"],
	scrollToSelectedItem: ["player", "scrollToSelectedItem"],
	assignmentId: ["assignmentId"],
	persistenceType: ["appState", "targetConfig", "type"],
	appPreferences: ["appPreferences"],
	showNavigationView: ["player", "showNavigationView"],
	showNavigationViewPlacement: ["player", "showNavigationViewPlacement"],
	promptModalMoveForwardVisible: playerPaths.PROMPT_MODAL_MOVE_FORWARD_VISIBLE,
	timersList: ["timersList"],
	timerVisible: ["appState", "timerVisible"],
	fixedValues: ["activity", "authorProperties", "fixedValues"],
	itemModalVisible: ["appState", "itemModal", "visible"],
	promptModal: ["appState", "promptModal"],
	miraSpeaking: ["miraSpeaking"],
	stateVariables: ["activity", "variables"],
	content: ["content"]
}, PlayerProcedure);